module.exports = __webpack_public_path__ + "img/sharecopy.7e111031.svg";